/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { EgridMeta } from './egridMeta';
import { HistInfoMeta } from './histInfoMeta';
import { GrundstueckId } from './grundstueckId';
import { TimePointId } from './timePointId';
import { CodeEntryMeta } from './codeEntryMeta';
import { GrundstueckNummerListEntry } from './grundstueckNummerListEntry';
import { GebaeudeArt } from './gebaeudeArt';
import { GrundstueckPermissions } from './grundstueckPermissions';


export interface GrundstueckListEntryMeta { 
    isKopie?: boolean;
    mIsKopie?: FieldMetaData;
    histInfo: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    sdrArt?: GrundstueckListEntryMeta.SdrArtEnum;
    mSdrArt?: FieldMetaData;
    grundstueckPDFpossible?: boolean;
    mGrundstueckPDFpossible?: FieldMetaData;
    isMeldungsrelevant?: boolean;
    mIsMeldungsrelevant?: FieldMetaData;
    sonderrechtText?: string;
    mSonderrechtText?: FieldMetaData;
    flurnamen?: Array<string>;
    mFlurnamen?: FieldMetaData;
    grundstueckRTFpossible?: boolean;
    mGrundstueckRTFpossible?: FieldMetaData;
    isNavigierbar?: boolean;
    mIsNavigierbar?: FieldMetaData;
    id: GrundstueckId;
    mId?: FieldMetaData;
    flaecheQuadratMeter?: number;
    mFlaecheQuadratMeter?: FieldMetaData;
    flaechenMaessigNichtAusgeschieden?: boolean;
    mFlaechenMaessigNichtAusgeschieden?: FieldMetaData;
    haengigeGeschaefteIds?: Array<TimePointId>;
    mHaengigeGeschaefteIds?: FieldMetaData;
    grundstueckArt?: GrundstueckListEntryMeta.GrundstueckArtEnum;
    mGrundstueckArt?: FieldMetaData;
    codeUnterart?: CodeEntryMeta;
    mCodeUnterart?: FieldMetaData;
    permissions?: GrundstueckPermissions;
    mPermissions?: FieldMetaData;
    egrid?: EgridMeta;
    mEgrid?: FieldMetaData;
    ligArt?: GrundstueckListEntryMeta.LigArtEnum;
    mLigArt?: FieldMetaData;
    gebaeudeArten?: Array<GebaeudeArt>;
    mGebaeudeArten?: FieldMetaData;
    dokulinkVerfuegbar?: GrundstueckListEntryMeta.DokulinkVerfuegbarEnum;
    mDokulinkVerfuegbar?: FieldMetaData;
    grundstueckNummer?: GrundstueckNummerListEntry;
    mGrundstueckNummer?: FieldMetaData;
}
export namespace GrundstueckListEntryMeta {
    export type SdrArtEnum = 'BAURECHT' | 'QUELLENRECHT' | 'KONZESSION' | 'UEBRIGES_RECHT';
    export const SdrArtEnum = {
        BAURECHT: 'BAURECHT' as SdrArtEnum,
        QUELLENRECHT: 'QUELLENRECHT' as SdrArtEnum,
        KONZESSION: 'KONZESSION' as SdrArtEnum,
        UEBRIGES_RECHT: 'UEBRIGES_RECHT' as SdrArtEnum
    };
    export type GrundstueckArtEnum = 'STOCKWERK' | 'LIEGENSCHAFT' | 'MITEIGENTUM' | 'UNBEKANNT' | 'FOLIO' | 'BERGWERK' | 'SDR';
    export const GrundstueckArtEnum = {
        STOCKWERK: 'STOCKWERK' as GrundstueckArtEnum,
        LIEGENSCHAFT: 'LIEGENSCHAFT' as GrundstueckArtEnum,
        MITEIGENTUM: 'MITEIGENTUM' as GrundstueckArtEnum,
        UNBEKANNT: 'UNBEKANNT' as GrundstueckArtEnum,
        FOLIO: 'FOLIO' as GrundstueckArtEnum,
        BERGWERK: 'BERGWERK' as GrundstueckArtEnum,
        SDR: 'SDR' as GrundstueckArtEnum
    };
    export type LigArtEnum = 'STR' | 'CFA' | 'DPI' | 'VEC' | 'VIC' | 'ADG' | 'UEBRIGEART';
    export const LigArtEnum = {
        STR: 'STR' as LigArtEnum,
        CFA: 'CFA' as LigArtEnum,
        DPI: 'DPI' as LigArtEnum,
        VEC: 'VEC' as LigArtEnum,
        VIC: 'VIC' as LigArtEnum,
        ADG: 'ADG' as LigArtEnum,
        UEBRIGEART: 'UEBRIGEART' as LigArtEnum
    };
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        DOKULINK_VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        DOKULINK_NICHT_VORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
}


